function mulberry32(seed) {
    let state = seed;
    return () => {
        state += 0x6d2b79f5;
        let t = state;
        t = Math.imul(t ^ (t >>> 15), t | 1);
        t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
        return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
    };
}

// Loading skeleton bar widths: each call of the returned function gives the
// next width (40-80%, as a CSS percentage) of a fixed pseudo-random sequence,
// so every render of the loading rows looks the same. Used by DataTable, the
// Watchlist grid and the Watchlist history snapshot table.
export function createSkeletonWidths() {
    const random = mulberry32(12345);
    return () => `${Math.round(40 + (40 * random()))}%`;
}
